import React from 'react';
import _sharedStylesRaw from './ClubShared.module.css';
const sharedStyles = (typeof _sharedStylesRaw === 'object' && _sharedStylesRaw !== null) ? _sharedStylesRaw : {};
import styles from './ClubMetricSection.module.css';

export default function ClubMetricSection({ title, metrics, variant }) {
    if (variant === 'pulse') {
        // Find the dynamic max for the axis
        const rawValues = metrics.map(m => parseFloat(String(m.value)) || 0);
        const highestVal = Math.max(...rawValues, 60); // Minimum 60 for the scale
        const axisMax = Math.ceil(highestVal / 20) * 20; // Round up to nearest 20 for clean axis
        
        const labels = [
            0,
            Math.round(axisMax * 0.5),
            Math.round(axisMax * 0.75),
            axisMax
        ];

        return (
            <section className={sharedStyles.section}>
                <h2 className={sharedStyles.sectionTitle}>{title}</h2>
                <div className={styles.pulseContainer}>
                    <span className={styles.comparisonLabel}>Comparison</span>
                    <div className={styles.barStack}>
                        {metrics.map((metric, i) => (
                            <div key={i} className={styles.barItem}>
                                <div className={styles.barLabel}>
                                    <strong>{metric.label}</strong> <span>{metric.value}</span>
                                </div>
                                <div className={styles.barBg}>
                                    <div 
                                        className={styles.barFill} 
                                        style={{ 
                                            width: `${(parseFloat(metric.value) / axisMax) * 100}%`,
                                            background: i === 0 ? '#f2aa30' : '#fff'
                                        }} 
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.barAxis}>
                        {labels.map(l => <span key={l}>{l}</span>)}
                    </div>
                </div>
            </section>
        );
    }

    if (variant === 'cards') {
        // Large Cards Variant
        return (
            <section className={sharedStyles.section}>
                <h2 className={sharedStyles.sectionTitle}>{title}</h2>
                <div className={styles.cardsGrid}>
                    {metrics.map((metric, i) => (
                        <div key={i} className={styles.metricCard}>
                            <div className={styles.cardValue}>{metric.value}</div>
                            <div className={styles.cardLabel}>{metric.label}</div>
                        </div>
                    ))}
                </div>
            </section>
        );
    }

    return (
        <section className={sharedStyles.section}>
            <h2 className={sharedStyles.sectionTitle}>{title}</h2>
            <div className={styles.metricsGrid}>
                {metrics.map((metric, i) => (
                    <div key={i} className={styles.metricItem}>
                        <div className={styles.value}>{metric.value}</div>
                        <div className={styles.label}>{metric.label}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}
